<template>
  <div class="section4 f-p-section">
    <div class="bg bg1"></div>
    <div v-if="isMobile" class="bg bg1 wave"></div>
    <div class="bg bg2"></div>
    <div
      class="building"
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-delay="0"
    ></div>
    <div
      class="building-title"
      data-aos="fade"
      data-aos-duration="1000"
      data-aos-delay="200"
    >
      <img
        class="title"
        src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 244.03 116.13'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23bd802f;%7D.cls-2%7Bfill:%23231815;%7D.cls-3%7Bfill:%230071b6;%7D%3C/style%3E%3C/defs%3E%3Cg id='圖層_2' data-name='圖層 2'%3E%3Cg id='圖層_2-2' data-name='圖層 2'%3E%3Cpath class='cls-1' d='M104.87,29.22a27.65,27.65,0,0,0-6.15-3.62L101,22.46a23.82,23.82,0,0,1,6.33,3.27Zm2.75,4.7c-1.41,3.78-3.17,7.87-4.82,11.33L99,42.9a92.46,92.46,0,0,0,5.24-11.37Zm-1.4-13.86a23.43,23.43,0,0,0-5.87-3.66l2.32-3.11a25.24,25.24,0,0,1,6,3.34Zm7,5.51c0,5.81-.59,14.42-4.07,19.91a14.26,14.26,0,0,0-3.5-2c3.31-5.18,3.64-12.7,3.65-18l0-9.49,9.46,0a20.68,20.68,0,0,0-.87-2.39l3.88-.86A28.58,28.58,0,0,1,123.07,16l8.08,0v3.46l-17.95,0v2.83H116V20.11h3.68v2.21h4.52V20.13H128v2.21h3v3.25H128v5.15l-12,0V25.58ZM130.31,33a17.57,17.57,0,0,1-5,7.13,27.66,27.66,0,0,0,6.47,1.94,12.92,12.92,0,0,0-2.49,3.46,24.35,24.35,0,0,1-7.55-3,31.68,31.68,0,0,1-8.27,3,13.37,13.37,0,0,0-2-3.36,29.12,29.12,0,0,0,7.08-2.12A19.77,19.77,0,0,1,115,35.3h-1.36V32l12.67,0v0h.77l.7-.14Zm-11,2.28A12,12,0,0,0,122,38.09a14,14,0,0,0,2.84-2.76Zm.38-9.73v2h4.52v-2Z'/%3E%3Cpath class='cls-1' d='M143.16,14.06A61.43,61.43,0,0,1,141,21L141,45.73h-4l0-16.8a25.78,25.78,0,0,1-1.61,2.13,18.6,18.6,0,0,0-2-4.42c2.67-3.25,4.68-8.32,5.81-13.53ZM147.3,39l0,6.76h-3.81l.07-31.29,10,0,0,12h-6.16v2.66h5.57v3.4l-5.57,0v3l6,0V39Zm0-21.1v5.21h2.59V17.85Zm18,10.89a25.57,25.57,0,0,1-3.95,10.39,14.48,14.48,0,0,0,5.42,3.62,15.06,15.06,0,0,0-2.43,3.1,16,16,0,0,1-5.38-4,19.74,19.74,0,0,1-6.41,4,12,12,0,0,0-2.06-3,15.3,15.3,0,0,0,6.27-3.91A31.28,31.28,0,0,1,153.9,32l2.06-.48h-2.27V28.15l8.64,0,.63-.1Zm-.56-2.35-10.18,0v-3.5H161L161,18l-6.37,0v-3.5l10.19,0Zm-7.68,5.13a20.15,20.15,0,0,0,2,4.52A21,21,0,0,0,161,31.53Z'/%3E%3Cpath class='cls-2' d='M50.75,0c1.93,4.42,3.79,8.86,5.68,13.29L62,26.63c1.83,4.45,3.9,8.81,5.4,13.39a113.67,113.67,0,0,1,3.87,14l-.28.11a112.81,112.81,0,0,1-6.39-13c-1.91-4.43-3.26-9.06-4.84-13.61L55,13.82C53.51,9.25,52,4.69,50.47.11Z'/%3E%3Cpath class='cls-2' d='M212.25.11c-1.49,4.58-3.05,9.14-4.57,13.71L203,27.48c-1.59,4.55-2.93,9.18-4.85,13.61a112.74,112.74,0,0,1-6.38,13l-.28-.11a111.89,111.89,0,0,1,3.86-14c1.5-4.58,3.58-8.94,5.41-13.39l5.54-13.34C208.18,8.86,210,4.42,212,0Z'/%3E%3Cpath class='cls-3' d='M31.54,91.17l.91,4.43L.91,102.08,0,97.66Z'/%3E%3Cpath class='cls-3' d='M69.17,101.22l.44,3.26-21,2.8L48.18,104,57,102.84l-.21-1.56-6.91.92-.41-3.12,6.9-.93-.21-1.59-6.66.89-.41-3.06-1.87,3.43a32,32,0,0,0-2.55-3.23l1.8,13.54-4,.53L40.85,96.2A30.71,30.71,0,0,1,38,103.58a20.49,20.49,0,0,0-2.43-3.67,34.42,34.42,0,0,0,3.9-10L35,90.51l-.51-3.85,5-.66L39,82c-1.42.47-2.81.9-4.14,1.25a14.24,14.24,0,0,0-1.56-3,49.81,49.81,0,0,0,10.37-4.32l3.16,2.8a36.47,36.47,0,0,1-4,1.87l.65,4.89,3.71-.5.52,3.85-3.72.5.14,1c1,.64,4.08,3.09,5,3.89L48,85.82l6.66-.89-.19-1.42-7.81,1-.42-3.19,7.8-1-.19-1.46c-2.24.41-4.45.77-6.53,1.08A11,11,0,0,0,46,77a120.73,120.73,0,0,0,16.25-3.62L65,76.13a67.89,67.89,0,0,1-7.26,1.93L58,79.79l7.46-1L65.87,82l-7.46,1,.19,1.43,6.9-.92,1.55,11.62-6.9.92.21,1.6,6.9-.92.42,3.12-6.91.92.21,1.56Zm-17-11.29,3.09-.42L55,87.81l-3.08.42Zm3.65,3.78-.24-1.77-3.08.41.23,1.77ZM59,87.29l.23,1.7,3.19-.43-.23-1.7ZM62.72,91l-3.19.43.24,1.77L63,92.76Z'/%3E%3Cpath class='cls-3' d='M103,97.85l.25,4.09-31.4,2-.25-4.08L85,99l-.44-7-9.47.59-.25-4,9.46-.6L84,81.79l-7.23.46a29.5,29.5,0,0,1-2.93,5.27,32.38,32.38,0,0,0-3.9-2.25c2.54-3.1,4.51-8.07,5.4-12.89l4.36.67c-.39,1.71-.84,3.38-1.34,5l5.38-.34-.39-6.29,4.36-.27.4,6.29,11.77-.74.26,4-11.78.74.39,6.15L99.14,87l.26,4L89,91.68l.45,7Z'/%3E%3Cpath class='cls-3' d='M112.22,87.06c-1.43-1-4.43-2.69-6.49-3.82L108,80.17c1.92,1,5,2.48,6.56,3.44Zm-6.1,12.57a101.67,101.67,0,0,0,6.72-11l3,2.82c-1.88,3.66-4.11,7.64-6.26,11Zm7.67-22.12a73.41,73.41,0,0,0-6.35-3.89l2.36-3c2,1,5,2.55,6.49,3.54Zm15.46,6.92,0,4.42,7.14,0-.09,14-4,0v-1.26l-10.53-.06v1.43l-3.75,0,.09-14.14,7.14,0,0-4.41L116,84.35l0-4,9.31.06,0-4.1c-2.32.34-4.63.57-6.83.77a14.92,14.92,0,0,0-1.14-3.58c6-.56,12.51-1.67,16.37-3.19l3.2,3.31a45.18,45.18,0,0,1-7.64,2l0,4.79,8.89.06,0,4Zm3.14,8.22-10.54-.07,0,5.15,10.53.06Z'/%3E%3Cpath class='cls-3' d='M146.59,93.77a33.87,33.87,0,0,1-4.07,6.89,24.72,24.72,0,0,0-2.58-2.09,25.32,25.32,0,0,0,3.54-5.95Zm5-1.66-.87,11.59-4-.31.87-11.58-6.49-.49.26-3.49,6.49.49.2-2.69-6.7-.5.26-3.42L145,82a21.08,21.08,0,0,0-.74-3.7l2.91-.49-4.71-.35.26-3.39,6,.45c-.24-1-.55-2-.84-2.83l4.23-.7c.44,1.19,1,2.67,1.29,3.88l5,.38-.25,3.38-4.37-.32,2.79.77c-.63,1.28-1.25,2.61-1.86,3.65l3.63.27-.25,3.42-6-.45-.2,2.69,5.41.41L157,92.52Zm-4-14.3a17.56,17.56,0,0,1,.87,3.71L146,82l5,.38a40.91,40.91,0,0,0,1.83-4.21Zm25.92,10.47L170.32,88,169,105.18l-4.05-.31,1.29-17.13L163,87.49l0,.42c-.39,5.13-1.39,12.29-4.69,16.53a15.5,15.5,0,0,0-3-2.72,13.3,13.3,0,0,0,1.82-3.27l-2.59,1.35a41.3,41.3,0,0,0-2.33-5.44L155,93.1a35.35,35.35,0,0,1,2.28,4.77,38.17,38.17,0,0,0,1.86-10.25l.93-12.42A49.88,49.88,0,0,0,170.89,73l3,3.27a54,54,0,0,1-10.11,1.87l-.42,5.48,10.54.8Z'/%3E%3Cpath class='cls-3' d='M186.88,100.8l-7-1-.45,3-3.81-.55,3.88-26.6,10.84,1.58Zm-3.31-4.23,1-6.51-3.19-.47-1,6.51Zm-.82-16.68-.89,6.1,3.18.46.89-6.09ZM202,84.26l-.47,3.29,6.85,1-.52,3.57-2.52-.37-.4,2.7,3.33.48-.52,3.57L204.44,98l-1.1,7.55c-.29,2-.82,3-2.29,3.38s-3.33.22-5.89-.15a15.1,15.1,0,0,0-.72-4.07c1.66.31,3.56.59,4.08.67s.75,0,.82-.52l1.08-7.45L188.3,95.67l.52-3.57,12.12,1.76.4-2.7-11.05-1.61.52-3.57,6.68,1,.48-3.29-7.79-1.14.52-3.6,7.8,1.13.54-3.7,4.05.59-.54,3.71,7.79,1.13-.52,3.6Zm-9,12.59a43.71,43.71,0,0,1,3.35,6.15l-3.91,1.58a49.66,49.66,0,0,0-3.14-6.4Z'/%3E%3Cpath class='cls-3' d='M238.26,112.68c-.43,1.95-1,3-2.51,3.29s-3.27,0-5.83-.52a12.5,12.5,0,0,0-.46-4.15c1.63.43,3.44.82,4,.91s.72,0,.82-.5l3-13.85L218.7,93.79l-4,18.44-4.07-.89,4.85-22.23,11.15,2.43,2.12-9.71,4.17.91-2.12,9.71,11.36,2.48ZM219.31,89.52a30.91,30.91,0,0,0-2.52-7.82l4-.72a29.6,29.6,0,0,1,2.78,7.6Zm3.23,18.37-.46,2.12-3.66-.8,2.71-12.41,12.62,2.75-2.25,10.29Zm1.51-6.91-.77,3.52,5.16,1.13.77-3.52Zm20-13.73a58.15,58.15,0,0,1-6.45,6.22l-3.12-2.11a44.28,44.28,0,0,0,5.8-6.4Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
        alt=""
        srcset=""
        data-aos="fade"
        data-aos-duration="1000"
        data-aos-delay="200"
      />
      <p
        class="content"
        data-aos="fade"
        data-aos-duration="1000"
        data-aos-delay="500"
      >
        漫步行旅，邂逅美好旅居生活，<br />
        同時擁有太平洋斷層海岸、三面山巒疊翠，<br />
        享受山海、水陸的雙棲渡假生活。
      </p>
      <img
        class="para"
        data-aos="fade"
        data-aos-duration="1000"
        data-aos-delay="1000"
        src="./s4/style.png"
        alt=""
      />
    </div>
    <div
      class="tra-title"
      data-aos="fade"
      data-aos-duration="1000"
      data-aos-delay="200"
    >
      <img
        class="title"
        src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 293.9 125.27'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23bd802f;%7D.cls-2%7Bfill:%23231815;%7D.cls-3%7Bfill:%230071b6;%7D%3C/style%3E%3C/defs%3E%3Cg id='圖層_2' data-name='圖層 2'%3E%3Cg id='圖層_2-2' data-name='圖層 2'%3E%3Cpath class='cls-1' d='M97.49,14.24c-.21.42-.39.8-.56,1.22a31.68,31.68,0,0,0,9,8.63,15.57,15.57,0,0,0-2.67,3.29,30.32,30.32,0,0,1-3-2.63v2.31L90,27V25.14a32.11,32.11,0,0,1-2.88,2.58A16.71,16.71,0,0,0,84.79,25L84.74,45.6H81.07V39.68c-2.66.48-5.29,1-7.53,1.35l-.76-3.85,1.75-.25,0-19H73.05V14.21l13.68,0V18H84.81l0,6.51a31.64,31.64,0,0,0,9.27-11.6ZM81.09,36V32.12H78.16v4.31Zm-2.92-7.25h2.94V25H78.18Zm0-10.78v3.67h2.95V17.94Zm25.73,13.18a49,49,0,0,1-6.63,9.19c1.22,1.06,2.34,2.08,3.14,2.92l-3,2.65a107.21,107.21,0,0,0-8.38-8l2.74-2.33,2.58,2.21a46.6,46.6,0,0,0,4.11-4.89l-10.89,0v-3.5l13.13,0,.56-.24Zm-4.84-7.6a46.34,46.34,0,0,1-3.91-5,34.44,34.44,0,0,1-3.65,5Z'/%3E%3Cpath class='cls-1' d='M116.37,34.2a20,20,0,0,1-2.66.38V36.5h1.82v2.55H113.7v1.5l2.38-.23,0,2.76c-2.87.34-5.71.65-8.13.89l-.27-3,2.94-.21V39.05h-2V36.49h2V34.82c-.74,0-1.44,0-2,0a13.64,13.64,0,0,0-.7-2.28,50.84,50.84,0,0,0,7.15-.82Zm21.26,9.64a12.35,12.35,0,0,0-.93-2.8c-.43,3.29-1.38,4.16-3.69,4.16h-3.54c-3.32,0-4-1-4-4V38.14A27.77,27.77,0,0,1,123,44.23l-2.48-1.69v3.12h-3.78l0-14.95c-3.08.27-6.09.44-8.58.61l-.31-3.26,1.75-.06,0-10.36H108V14.33l14.07,0v3.29h-1.47L120.52,42a22,22,0,0,0,2.36-5.56l2.59,1.12V36.46h3.05c-.35-.39-.67-.77-1-1.09l2.14-1.08-8,0v-3.5l18.52,0v3.5l-9.73,0a19.91,19.91,0,0,1,3.63,4.63l-2.77,1.61A22.14,22.14,0,0,0,128.93,37v4.16c0,.84.11,1,1.05,1h2.63c.8,0,1-.35,1.09-2.8a9.08,9.08,0,0,0,2.66,1.2,15.87,15.87,0,0,0-2.17-3.44L137,35.83a17.78,17.78,0,0,1,3.66,6.69ZM116.78,27.66V25.91h-3.43v1.92Zm-3.42-4.28h3.43V21.77h-3.43Zm0-5.74v1.61h3.43V17.65Zm15.08,2.94c.11-.53.21-1.12.28-1.72h-6.51V15.59l7,0c.1-.84.18-1.64.25-2.38l3.6.25-.28,2.14,7,0v3.25l-7.46,0c-.1.6-.17,1.19-.28,1.72h7.21l0,8.83-16.59,0,0-8.83Zm-.92,2.94h-1.85v2.91h1.85Zm4.2,0h-1.89v2.91h1.89Zm2.34,2.91h2v-2.9h-2Z'/%3E%3Cpath class='cls-1' d='M165.48,34.7a14.13,14.13,0,0,1-2.15,5,49.18,49.18,0,0,0,12.46,2,16.54,16.54,0,0,0-2.53,3.87,39.91,39.91,0,0,1-12.91-3,22.8,22.8,0,0,1-6.87,3.21A19.23,19.23,0,0,0,151,42.37a19.92,19.92,0,0,0,5.67-1.91,18.21,18.21,0,0,1-4.15-4.07l3.61-1.25a13.2,13.2,0,0,0,3.56,3,8.37,8.37,0,0,0,1.69-3.4h-7.63l0-14.08,8.05,0v-2.1l-8.51,0V15.39a66,66,0,0,1-2.89,6.5l0,23.8h-4l0-17.33a26,26,0,0,1-1.79,2.23,31,31,0,0,0-2.27-4.31,37.52,37.52,0,0,0,7.39-13.11l3.91,1.24-.17.45,21.24.06v3.64l-8.78,0v2.1l7.91,0,0,14.08Zm-3.74-3.05c0-.45,0-.94,0-1.36V29.06h-4.2v2.59Zm-4.15-5.43h4.2V23.67h-4.2Zm12.21,2.86h-3.89v1.26c0,.42,0,.88,0,1.33h3.92Zm-3.87-5.4v2.56h3.89V23.69Z'/%3E%3Cpath class='cls-1' d='M188.62,31.58c-1.12.34-2.24.69-3.36,1l0,8.86c0,1.92-.33,3-1.38,3.64s-2.55.79-4.86.75A17.58,17.58,0,0,0,178,42a26.59,26.59,0,0,0,2.87,0c.42,0,.6-.14.6-.59V33.69c-1.15.35-2.31.66-3.32.94l-.9-4c1.19-.24,2.66-.63,4.23-1l0-6.05h-3.68V19.75h3.68l0-6.58h3.78l0,6.58h3.18v3.81h-3.19v5l2.84-.8Zm12.19,10.28a25.6,25.6,0,0,0,2.94.15c1.09,0,5.25,0,6.69-.06a11.79,11.79,0,0,0-1.17,3.57h-5.81c-4.83,0-8.61-.86-11.26-4.16A14.48,14.48,0,0,1,189.11,46,21.85,21.85,0,0,0,186,43.72c2.52-2.2,3.79-5.81,4.33-9.9l3.77.5a30.13,30.13,0,0,1-.63,3.25A7.67,7.67,0,0,0,197,40.84l0-7.49-6.54,0V30.25l6.55,0V28.48l-8.57,0V25.24l8.57,0V23.65l-6.55,0V20.52l6.54,0V19.06h-8V15.79l8,0V13.18h3.85v2.63l8.78,0V19.1l-8.78,0v1.47l7.42,0v4.73h2.17v3.22h-2.17l0,4.86h-7.42v2h7.66v3.26l-7.67,0Zm0-11.59h3.57V28.5h-3.58Zm0-5h3.57V23.67h-3.57Z'/%3E%3Cpath class='cls-2' d='M39.54,0c1.93,4.42,3.79,8.86,5.68,13.29l5.55,13.34c1.83,4.45,3.9,8.81,5.4,13.39A113.67,113.67,0,0,1,60,54l-.28.11a112.81,112.81,0,0,1-6.39-13c-1.91-4.43-3.26-9.06-4.85-13.61l-4.7-13.66C42.3,9.25,40.74,4.69,39.26.11Z'/%3E%3Cpath class='cls-2' d='M241,.11c-1.49,4.58-3,9.14-4.57,13.71l-4.7,13.66c-1.59,4.55-2.93,9.18-4.85,13.61a112.74,112.74,0,0,1-6.38,13l-.28-.11a111.89,111.89,0,0,1,3.86-14c1.5-4.58,3.57-8.94,5.4-13.39l5.55-13.34C237,8.86,238.82,4.42,240.76,0Z'/%3E%3Cpath class='cls-3' d='M25.88,83.37l.93,4.1L.92,93.3,0,89.2Zm6.89,22,.94,4.17L4.07,116.2,3.13,112ZM25.64,94.87,26.57,99,5.74,103.69l-.93-4.13Z'/%3E%3Cpath class='cls-3' d='M66.41,88.18a41.59,41.59,0,0,1-2.49,12.06c.61,1.68,1.19,2.47,1.64,2.41s.63-1.48.15-5.3a10.14,10.14,0,0,0,3,1.56c.52,6-.32,7.2-2.88,7.63-1.42.21-2.71-.58-3.81-2.25a26.43,26.43,0,0,1-2.41,3.44,25.24,25.24,0,0,0-3-2.12l.18-.2-8.32,2.33-.59-2c-3.53,1.5-7.17,3-10,4.15l-1.29-3.6c1.25-.4,2.73-.94,4.41-1.52L39.6,96.08l-4.12.63L35,93.21l4.12-.62-.38-2.53-2.36.36-.27-1.77c-.38.52-.76,1-1.15,1.49a28.36,28.36,0,0,0-2-4.06,21.78,21.78,0,0,0,4.83-8.49l2.91,1a13.14,13.14,0,0,1-.41,1.3,32.73,32.73,0,0,1,5.1,3l-.51,1.78,4-.6-.3-1.94-3,.46L45,79.43,48,79l-.4-2.66,3.63-.56.41,2.67,2.9-.45.48,3.15-2.9.44.29,1.94,3.74-.57c-.4-2.41-.83-5-1.25-7.74l3.88-.59c.35,2.82.71,5.38,1.11,7.76l5.6-.85.5,3.25-5.57.85c.53,3.29,1.1,6.07,1.67,8.42a36.54,36.54,0,0,0,.72-6Zm-28.24,9.4a48.27,48.27,0,0,1,2,5.74l-2.27,1.16A39.92,39.92,0,0,0,36,98.65Zm5.32-11.76a29.37,29.37,0,0,0-4.41-2.72c-.56,1.25-1.18,2.51-1.85,3.68ZM58.61,103a24.68,24.68,0,0,0,1.52-2.79,94.54,94.54,0,0,1-3.38-14L45.06,88l-.4-2.6-.32,1.11a5.86,5.86,0,0,1-.53-.41l.48,3.15-2.59.39.38,2.53,3.6-.55.53,3.5-3.6.54,1.24,8.1c1.17-.43,2.34-.89,3.55-1.32l.5,2.33c1.13-.24,2.46-.58,3.89-.94l-.21-1.39-3.15.48-.41-2.7,3.15-.48L51,98.49c-1.12.28-2.19.48-3.23.64a9.42,9.42,0,0,0-1-2c-.26,2-.49,4.21-.69,5.66l-2.2-.44a46.77,46.77,0,0,0,.19-6l2.75.39v.15a52.59,52.59,0,0,0,9-2.5l2.52,2a33.74,33.74,0,0,1-3.84,1.29l.24,1.53,2.87-.44.41,2.7-2.87.44.15,1,3.24-.85ZM46.37,88.89l9.69-1.47,1,6.57-9.69,1.48Zm3.56,3.64L53.56,92l-.24-1.59-3.63.56ZM62.38,81.71a24.92,24.92,0,0,0-3.27-4.92l2.78-1.74a25.18,25.18,0,0,1,3.41,4.73Z'/%3E%3Cpath class='cls-3' d='M101.83,88.1l.33,4.05L70.39,94.73l-.33-4,7.5-.61L77,83.38l-6.28.51-.32-4,6.27-.51-.52-6.45,4.33-.36L81,79l8-.66-.52-6.45,4.32-.35L93.36,78l6.52-.53.33,4L93.68,82l.55,6.7ZM84.06,96.67a43.44,43.44,0,0,1-9.14,8.93A30.06,30.06,0,0,0,71.27,103a31.32,31.32,0,0,0,8.26-7.66Zm-2.18-6.94,8-.66-.54-6.7-8,.66Zm10.65,4.43a102.9,102.9,0,0,1,10.1,6.73l-3.92,2.77a83.67,83.67,0,0,0-9.81-7.13Z'/%3E%3Cpath class='cls-3' d='M115.41,92.4c-.47-1.08-1.26-2.72-2-4.28l.19,14.91-3.78,0L109.61,90a29.67,29.67,0,0,1-3.11,6.94,19,19,0,0,0-1.86-3.65c1.93-2.76,3.72-7.65,4.55-11.79l-3.89,0,0-3.85,4.2-.05-.09-7.21,3.78,0,.09,7.21,3.5,0,0,3.85-3.5,0,0,1.65c1,1.35,3.64,5.35,4.21,6.32Zm22.5,4.87-1.89,0,0,1.5c0,1.75-.32,2.63-1.47,3.2s-2.79.6-5,.63a14,14,0,0,0-1.12-3.28c1.3.05,2.73,0,3.15,0s.59-.12.59-.54l0-1.47-9.84.12.07,5.22-3.75,0-.06-5.21-2.14,0,0-3,2.13,0-.1-8.75,6.72-.08,0-1.33-8.22.1,0-2.94,4.34,0,0-1.47-2.87,0,0-2.8,2.87,0,0-1.44-3.61,0,0-2.87,3.61,0,0-2.55,3.85,0,0,2.55,3.85,0,0-2.56,3.89,0,0,2.55,3.92,0,0,2.87-3.92,0V77l3.36,0,0,2.8-3.36,0,0,1.47,4.55-.06,0,2.94-8.5.1v1.33l7-.08.1,8.75,1.89,0Zm-15.68-8.73V90l3,0,0-1.51Zm.07,5.88,3,0,0-1.68-3,0ZM125,77.09l3.85,0,0-1.43-3.85,0Zm0,4.27,3.85,0,0-1.47-3.85,0ZM129,88.45,129,90l3.11,0,0-1.5Zm3.18,5.85,0-1.68-3.11,0,0,1.68Z'/%3E%3Cpath class='cls-3' d='M160.47,89.15l-.93,1.56,12.61.71s-.05.91-.11,1.36c-.67,6.73-1.17,9.47-2.07,10.4a3.14,3.14,0,0,1-2.23,1.07,21,21,0,0,1-3.46-.13,9.17,9.17,0,0,0-.73-3.3,17.93,17.93,0,0,0,2.44.31,1.1,1.1,0,0,0,1-.36c.45-.46.79-2.09,1.23-6.27l-.87,0a25.14,25.14,0,0,1-7.31,9.61,22.58,22.58,0,0,0-2.69-2,19.48,19.48,0,0,0,6.58-7.86l-1.61-.09a25.24,25.24,0,0,1-8.15,8.37,18.73,18.73,0,0,0-2.69-2.11A19.36,19.36,0,0,0,158.65,94L157,93.86a21,21,0,0,1-3.9,3.35A19.19,19.19,0,0,0,150.42,95a17.76,17.76,0,0,0,6.31-6.06l-2.94-.16-.17,3-4.79-.27-.67,11.78-3.77-.22.67-11.77-1.43-.08-.1,1.64-3-.17,1-17.58,4.44.25.27-4.85,3.77.21-.27,4.86,4.79.27L154,85.13l19,1.08-.21,3.64Zm-16.64-1.44,1.78.1.17-3-1.78-.1Zm.5-8.91-.15,2.69,1.78.1.15-2.69Zm6.24,9.29.17-3L148.89,85l-.17,3Zm.51-8.91-1.86-.1-.15,2.69,1.85.1Zm20.08,5.63-15.27-.87.69-12.12,15.27.87Zm-3.58-4.9-7.72-.44-.1,1.71,7.72.44Zm.25-4.44L160.11,75,160,76.68l7.72.44Z'/%3E%3Cpath class='cls-3' d='M185.48,89.84a43.16,43.16,0,0,1-3.89,8.71c.52.39,1.11,1,2,1.63,2.18,1.72,5.42,2.35,9.48,2.86a117.33,117.33,0,0,0,14.18.88,15.48,15.48,0,0,0-1.75,4.09c-2.87-.19-9-.73-13.11-1.24-4.62-.59-7.49-1.34-9.8-3.12-1.36-1-2.43-2.28-3.16-2.38s-2.35,2.11-3.43,4L173.73,101a15.53,15.53,0,0,1,4-2.84,34.23,34.23,0,0,0,2.78-5.79l-4.37-.56c1.06-1.94,2.35-4.6,3.45-7.21l-3.12-.4.46-3.65,8.13,1c-1,2.34-2.22,5-3.33,7.31l1.39.18.64-.06ZM180.77,80c-.18-1.64-.77-4.26-1.11-6.24l3.78-.62c.43,1.93,1,4.36,1.29,6Zm9.68,3.81L186,83.24l.38-3,9.13,1.16.23-1.77-6.88-.87.36-2.85,6.88.87.26-2.05,4.1.52-.26,2,7.15.91L207,81.07l-7.16-.91-.22,1.77,9.24,1.17-.38,3-4.76-.61.81.32c-.69.94-1.32,1.74-1.9,2.41l5.11.64-.37,2.92-8.86-1.12-.2,1.56,7.61,1L205.59,96l-7.61-1-.21,1.66,8.93,1.14-.38,3-8.93-1.13-.35,2.78-4.1-.52.35-2.78-8.64-1.1.38-3,8.64,1.09.22-1.66-7.3-.93.36-2.85,7.3.93.2-1.56L185.83,89l.37-2.91,4.52.57a11.86,11.86,0,0,0-.74-2.85Zm8.49,3.72a27.4,27.4,0,0,0,1.37-2.47l-6.39-.81a11.62,11.62,0,0,1,.71,2.73l-1,.09,6,.77Z'/%3E%3Cpath class='cls-3' d='M208.41,107.79a33.5,33.5,0,0,0,5.18-5.93l3.74,1.82a44.93,44.93,0,0,1-5.26,6.52Zm29.87-10-.86,4.36,4.12.81-.73,3.64-30.62-6.09.72-3.63,4.71.93.86-4.36-3.67-.73.72-3.64,3.68.73.61-3.09,3.64.72-.61,3.09,2.33.47.61-3.09,3.4.67-.61,3.09,2.68.54.61-3.09,3.4.67-.61,3.09,2.57.51.61-3.08,3.78.75L239,94.11l3.36.66-.72,3.64Zm-19.52-12.2a30.42,30.42,0,0,1-4.78,3,24.39,24.39,0,0,0-1.67-3.76A22.85,22.85,0,0,0,221,78.08l3.3,1.87a23.86,23.86,0,0,1-2.18,2.53l21.6,4.29-.72,3.6ZM223,104.74a40.27,40.27,0,0,1-.42,6.59l-4.13-.22a40.65,40.65,0,0,0,.66-6.72Zm-3.76-6.25,2.34.47.87-4.36-2.34-.47Zm6.6-3.22L225,99.63l2.68.54.86-4.36Zm4.22,10.58a34.79,34.79,0,0,1,.76,6.76l-4.24,0a35.41,35.41,0,0,0-.49-6.88ZM234.51,97l-2.58-.51-.87,4.36,2.58.51Zm2.62,9.27a50.09,50.09,0,0,1,2.67,7.56l-4.37,1a49.3,49.3,0,0,0-2.35-7.74Z'/%3E%3Cpath class='cls-3' d='M274.26,119.29l-1.07,3.91-17.36-4.73.89-3.24c-5.13-.1-10.64-.37-14.78-.51l.38-4c.53,0,1.17.1,1.81.13l3.08-11.27,3.28.89-2.91,10.64,1.58.06,3.46-12.66-4.53-1.23,3-11.18,11.72,3.2-3.05,11.17-3.65-1-1.08,4,4.12,1.12-.95,3.51-4.12-1.12-1.21,4.42,4.54.26-.49,3,1.15.31,5.61-20.56L262.41,94,263.49,90l17,4.63-1.08,4-11.81-3.22-.94,3.44,10.6,2.89-3.47,12.74-10.61-2.9L262,115.93ZM252.54,94.75,257.07,96l1.17-4.28-4.53-1.24Zm13.08,7.78-1.44,5.3,6.68,1.82,1.45-5.3Z'/%3E%3Cpath class='cls-3' d='M280.15,120.65a3.64,3.64,0,0,1,6.91,2.29,3.65,3.65,0,0,1-6.91-2.29Zm6.17-16.76,1.5-5,6.08,2-1.8,4.9-4.92,11-3.42-1.13Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
        alt=""
        srcset=""
      />
      <p v-if="!isMobile" class="content">
        百年來宜蘭重大交通建設之最 – 結合「宜蘭鐵路高架化」、<br />
        「高鐵延伸宜蘭」、「東部快鐵」的三鐵共構計畫，造就未來南港<br />
        到宜蘭市最快只要13分鐘，就能輕鬆將最美北緯24度盡收眼底，<br />
        細心品嚐宣蘭的生態旅遊、養生冷泉、油綠田園。
      </p>
      <p v-else class="content">
        百年來宜蘭重大交通建設之最<br />結合「宜蘭鐵路高架化」、「高鐵延伸宜<br />蘭」、「東部快鐵」的三鐵共構計畫，造就<br />未來南港到宜蘭市最快只要13分鐘，就能輕<br />鬆將最美北緯24度盡收眼底，細心品嚐宣蘭<br />的生態旅遊、養生冷泉、油綠田園。
      </p>
    </div>
    <div class="badge">
      <swiper ref="swiper1" :options="swiperOptions1">
        <swiper-slide
          v-for="(imgList, i) in imgList1"
          v-bind:key="i"
          v-bind:style="{ backgroundImage: `url(${imgList.img})` }"
          data-aos-duration="1000"
          data-aos="fade"
          :data-aos-delay="i * 350"
        >
          <div class="caption">
            <div class="title" v-html="imgList.title"></div>
            <img class="titleImg" :src="imgList.titleImg" />
            <div class="content" v-html="imgList.content"></div>
          </div>
        </swiper-slide>
      </swiper>
      <div v-if="isMobile" class="swiper-button-prev" slot="button-prev">
        <img src="./s4/slider_left.png" alt="" srcset="" />
      </div>
      <div v-if="isMobile" class="swiper-button-next" slot="button-next">
        <img src="./s4/slider_right.png" alt="" srcset="" />
      </div>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<style lang="scss" scoped>
/* 螢幕尺寸標準 */
.section4 {
  position: relative;
  margin-top: -10vh;
  height: auto;

  .bg {
    position: relative;
    height: 0;
    padding-bottom: 65.9%;
    &.bg1 {
      background-image: url("./s4/bg.jpg");
      background-size: cover;
    }
    &.bg2 {
      margin-top: -25vh;
      padding-bottom: 35.41%;
      background-image: url("./s4/tra.png");
      background-size: 100%;
      background-position: center;
    }
  }

  .building {
    position: absolute;
    top: 8vw;
    left: 8vw;
    width: 60vw;
    height: 38vw;
    background-image: url("./s4/img.jpg");
    border-radius: 50vw 40vw 50vw 40vw;
    background-size: 120% auto;
    background-position: center bottom;
    animation: border-radius 3s ease-in-out 2s infinite alternate;
    border-radius: 60% 40% 60% 40%;

    @keyframes border-radius {
      to {
        border-radius: 40% 60% 40% 60%;
      }
    }

    &::before {
      content: "";
      background-image: url("./s4/img2.png");
      background-size:  120% auto;
      position: absolute;
      width: 100%;
      height: 115%;
      left: 0;
      bottom: 0;
      background-position: center bottom;z-index: 7;
    }
  }

  .building-title {
    position: absolute;
    z-index: 6;
    top: 10vw;
    left: 66vw;
    width: 18vw;
    height: 18vw;
    border-radius: 10vw;
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0.2) -24%,
      rgba(255, 255, 255, 0.24) -19%,
      rgba(255, 255, 255, 0.33) -7%,
      rgba(255, 255, 255, 0.38) 5%,
      rgba(255, 255, 255, 0.4) 15%,
      #fff 74%
    );
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .title {
      margin-top: -3vw;
      width: 10.8vw;
    }
    .content {
      margin-top: 0.6vw;
      font-size: 0.8vw;
      line-height: 1.3vw;
    }
    .para {
      position: absolute;
      right: -9vw;
      top: 0;
    animation: para 5s ease-in-out infinite alternate;

    @keyframes para {
      to {
        transform: translateY(-30%);
      }
    }

    }

    }


  .tra-title {
    position: absolute;
    z-index: 6;
    bottom: 27vw;
    left: 16vw;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .title {
      margin-top: -3vw;
      width: 10.8vw;
    }
    .content {
      margin-top: 0.6vw;
      font-size: 0.8vw;
      line-height: 1.3vw;
    }
  }

  .badge {
    position: absolute;
    width: 50vw;
    bottom: 5vw;
    left: 25vw;
    .swiper-slide {
      height: 15vw;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;

      .caption {
        width: 15vw;
        height: 15vw;
        border-radius: 15vw;
        background: rgba(255, 217, 0, 0.863);
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -7.5vw;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        transition: all 0.5s;
        transform: scale(0);
        cursor: pointer;
        &.active {
          transform: scale(1);
        }
        .title {
          color: #29a5dc;
          font-weight: bold;
          font-size: 1.2vw;
          margin-bottom: 2vw;
          &::after {
            content: "";
            background-image: url("./s4/img_line.png");
            width: 6vw;
            height: 5vw;
            background-size: contain;
            position: absolute;
            background-repeat: no-repeat;
            left: 47%;
            margin-left: -2.5vw;
            top: 1.9vw;
          }
        }
        .titleImg {
          position: absolute;
          right: -2vw;
          top: 0;
          width: 43%;
        }
        .content {
          font-size: 0.8vw;
          line-height: 1.4vw;
        }
      }
    }
  }
}


@media screen and (min-width: 767px) and (max-width: 1300px) {
  .titleImg{
    width: 43%;
  }
}




/* 平板尺寸 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
}

/* 手機尺寸 */
@media only screen and (max-width: 767px) {
  .section4 {
    margin-top: 0;
    height: auto;

    .bg {
      position: relative;
      height: 0;
      top: -17vw;
      &.bg1 {
        background-image: url("./s4/bg.jpg");
        background-size: 400%;
        padding-bottom: 284vw;
        background-position: center;
        background-repeat: no-repeat;
      }
      &.bg2 {
        margin-top: -42vw;
        margin-bottom: -17vw;
        padding-bottom: 123vw;
        background-image: url("./s4/tra.png");
        background-size: 350%;
        background-position-y: 0;
        background-repeat: no-repeat;
      }
      &.wave {
        mask: url("./s4/section_mask_mo.png");
        mask-size: 100%;
        mask-repeat: no-repeat;
        position: absolute;
        top: -17vw;
        left: 0;
        width: 100%;
        z-index: 1;
      }
    }

    .building {
      top: 63vw;
      left: 50%;
      width: 100vw;
      height: 65vw;
      margin-left: -50vw;
    }

    .building-title {
      top: 5vw;
      left: 7vw;
      width: 86vw;
      height: 60vw;
      border-radius: 90vw;
      .title {
        width: 51.8vw;
      }
      .content {
        margin-top: 1.6vw;
        font-size: 4vw;
        line-height: 6.3vw;
      }
      .para {
        width: 23vw;
      }
    }

    .tra-title {
      width: 90vw;
      left: 5vw;
      bottom: unset;
      top: 144vw;
      padding: 20vw 8vw;
      border-radius: 90vw;
      white-space: nowrap;
      text-align: center;
      background-image: linear-gradient(
        to right,
        rgba(255, 255, 255, 0.2) -24%,
        rgba(255, 255, 255, 0.24) -19%,
        rgba(255, 255, 255, 0.33) -7%,
        rgba(255, 255, 255, 0.38) 5%,
        rgba(255, 255, 255, 0.4) 15%,
        #fff 74%
      );
      .title {
        width: 60vw;
      }
      .content {
        margin-top: 1.6vw;
        font-size: 4vw;
        line-height: 6.3vw;
      }
    }

    .badge {
      position: absolute;
      width: 100vw;
      bottom: 45vw;
      left: 0;
      .swiper-container {
        overflow: visible;
      }

      .swiper-slide {
        height: 70vw;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;

        .caption {
          width: 90vw;
          height: auto;
          border-radius: 5vw;
          background: rgba(255, 217, 0, 0.863);
          position: absolute;
          top: unset;
          bottom: -25vw;
          left: 50%;
          margin-left: -45vw;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          transition: all 0.5s;
          transform: unset;
          cursor: pointer;

          padding: 5vw;
          .title {
            color: #29a5dc;
            font-weight: bold;
            font-size: 8.2vw;
            margin-bottom: 2vw;
            &::after {
              content: "";
              display: none;

            }
          }
          .titleImg {
            position: absolute;
            right: unset;
            left: -5vw;
            top: -5vw;
            width: 25vw;
          }
          .content {
            font-size: 3.8vw;
            line-height: 6vw;
            text-align: center;
            width: 100%;
          }
        }
      }

      .swiper-button-prev,
      .swiper-button-next {
        img {
          width: 10vw;
        }
        &::after {
          display: none;
        }
      }
    }
  }
}

// 避免內容電腦過渡平板時，設計未考量的調整
@media only screen and (min-width: 1025px) and (max-width: 1199.98px) {
}

// 避免過度到 1280 x 720 時，設計未考量的調整
@media only screen and (min-width: 1025px) and (max-width: 1280px) {
}
</style>

<script>
// @ is an alias to /src
import { isMobile } from "@/utils";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "section4",
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },

  data() {
    return {
      isMobile,
      swiperOptions1: {
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          1000: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
        },
      },

      imgList1: [
        {
          img: require("./s4/img_1.png"),
          titleImg: require("./s4/img_1_style.png"),
          title: "蘇澳冷泉",
          content: !isMobile
            ? "｜養生冷泉｜<br>天下第一奇泉，東南亞獨一無二<br>之低溫碳酸礦泉冷泉，<br>經年恆溫22度。"
            : "｜養生冷泉｜<br>天下第一奇泉，東南亞獨一無二之低溫碳酸礦泉冷泉，經年恆溫22度。",
        },
        {
          img: require("./s4/img_2.png"),
          titleImg: require("./s4/img_2_style.png"),
          title: "五十二甲濕地",
          content: !isMobile
            ? "｜生態旅遊｜<br>五結私房景點，<br>孕育出豐富魚蝦資源，同時<br>也吸引了許多鳥類棲息。"
            : "｜生態旅遊｜<br>五結私房景點，孕育出豐富魚蝦資源，同時也吸引了許多鳥類棲息。",
        },
        {
          img: require("./s4/img_3.png"),
          titleImg: require("./s4/img_3_style.png"),
          title: "武荖坑風景區",
          content: !isMobile
            ? "｜油綠田園｜<br>新蘭陽八景之一，林木蒼鬱，<br>溪間可見苦花、溪哥於<br>潺潺溪水中悠然自得。"
            : "｜油綠田園｜<br>新蘭陽八景之一，林木蒼鬱，溪間可見苦花、溪哥於潺潺溪水中悠然自得。",
        },
      ],
    };
  },

  methods: {
    onHover() {
      $(".badge .swiper-slide").hover(
        function () {
          $(this).find(".caption").addClass("active");
        },
        function () {
          $(this).find(".caption").removeClass("active");
        }
      );
    },
  },

  mounted() {
    if (!isMobile) {
      this.onHover();
    }
  },
  created() {},
};
</script>
